<script>
  export let isChecked = false,
    isDisabled = false
</script>

<label class="inline-flex relative items-center cursor-pointer outline-none">
  <input bind:checked={isChecked} type="checkbox" class="sr-only peer" disabled={isDisabled} />
  <div
    class="relative outline-none w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"
  />
</label>
